<template>
    <xx-select
        v-if="!showText"
        v-model="innerValue"
        :list="list"
        :multiple="multiple"
        :disabled-ids="disabledIds"
        value-key="managementCityId"
        label-key="managementCityName"
        v-bind="$attrs"
        @change="onChange"
    />
    <span v-else>{{ listText }}</span>
</template>

<script>
/*
 * 经营城市 选择器
 */

export default {
    name: 'ManageCitySelect',
    props: {
        value: {
            type: [Array, Number, String],
            default: '',
            required: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        showText: {
            type: Boolean,
            default: false,
        },
        disabledIds: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            list: [],
            innerValue: this.value,
        };
    },
    computed: {
        listText() {
            const listMap = this.list.reduce((result, item) => {
                result[item.managementCityId] = item.managementCityName;
                return result;
            }, {});
            if (this.multiple) {
                return this.innerValue.map((val) => listMap[val]).join(', ');
            } else {
                return listMap[+this.innerValue];
            }
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal;
        },
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            await this.$hPost('/api/vss/shepherd/supplier/poi/getAllManagerCity', { includeTestPoi: true })
                .then((res) => { this.list = res.list; this.$emit('loaded', res.list); })
                .catch(() => { this.$message.error('获取经营城市失败'); });
        },
        onChange(val, item) {
            this.$emit('input', val);
            this.$emit('change', val, item || { managementCityId: '', managementCityName: '' });
        },
    },
};
</script>

<style>

</style>
